// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__W9iJK","page-content":"home_page-content__Kq6kM"};